var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4542_8026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 19.464C16.1214 19.464 19.4632 16.1223 19.4632 12C19.4632 7.87776 16.1214 4.53601 11.9992 4.53601C7.8769 4.53601 4.53516 7.87776 4.53516 12C4.53516 16.1223 7.8769 19.464 11.9992 19.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00028 17.4L17.4003 12L9.00028 6.60001V17.4ZM12.0003 24C10.3443 24 8.78428 23.688 7.32028 23.052C5.85628 22.416 4.58428 21.564 3.50428 20.484C2.42428 19.404 1.57228 18.132 0.936281 16.668C0.300281 15.204 -0.0117188 13.644 -0.0117188 11.988C-0.0117188 10.332 0.300281 8.77201 0.936281 7.30801C1.57228 5.84401 2.42428 4.57201 3.50428 3.49201C4.58428 2.41201 5.85628 1.56001 7.32028 0.924013C8.78428 0.288013 10.3443 -0.0239868 12.0003 -0.0239868C13.6563 -0.0239868 15.2163 0.288013 16.6803 0.924013C18.1443 1.56001 19.4163 2.41201 20.4963 3.49201C21.5763 4.57201 22.4283 5.84401 23.0643 7.30801C23.7003 8.77201 24.0123 10.332 24.0123 11.988C24.0123 13.644 23.7003 15.204 23.0643 16.668C22.4283 18.132 21.5763 19.404 20.4963 20.484C19.4163 21.564 18.1443 22.416 16.6803 23.052C15.2163 23.688 13.6563 24 12.0003 24Z",
    fill: "#FF6B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4542_8026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.e958ab11a8b2b1de552da1247ce40b72.svg";
export { ForwardRef as ReactComponent };